// app/frontend/components/EventForm/sections/LocationInfoSection.tsx
import React, { useRef, useState, useMemo } from 'react';
import { Accordion, Group, Text, SegmentedControl } from '@mantine/core';
import { IconMapPinFilled } from '@tabler/icons-react';
import { LocationInfoSectionProps } from '../types';
import AddressAutocomplete from '../../AddressAutocompleteMap';

const LocationInfoSection: React.FC<LocationInfoSectionProps> = ({
  form,
  address,
  setAddress,
  timezone,
  setTimezone,
  areas,
  cities,
  railsTimezoneData,
}) => {
  const renderRef = React.useRef(0);
  renderRef.current++;

  // console.log('🛐 LocationInfoSection render #', renderRef.current, {
  //   railsTimezoneDataLength: railsTimezoneData?.length,
  // });

  return (
    <Accordion multiple className="form-accordion">
      <Accordion.Item value="location-info">
        <Accordion.Control>
          <Group gap="xs">
            <IconMapPinFilled size={28} />
            <Text style={{ fontSize: '1.25rem', fontWeight: 'bold' }}>Location Info</Text>
          </Group>
        </Accordion.Control>
        <Accordion.Panel>
          <Text size="sm" fw={500} mt={3} style={{ color: '#FFF7ED' }}>
            Is this an online event or in-person event?
          </Text>
          <SegmentedControl
            name="online_event"
            color="orange"
            transitionDuration={300}
            transitionTimingFunction="linear"
            size="sm"
            data={[
              { label: 'In Person', value: 'false' },
              { label: 'Online', value: 'true' },
            ]}
            {...form.getInputProps('online_event')}
            style={{
              border: '2px solid orange',
              backgroundColor: 'white',
            }}
          />

          {form.values.online_event !== 'true' && (
            <AddressAutocomplete
              value={address}
              onChange={(newAddress) => {
                setAddress(newAddress);
                form.setFieldValue('address', newAddress);
              }}
              onTimezoneSelect={(newTimezone) => {
                setTimezone(newTimezone);
                form.setFieldValue('timezone', newTimezone);
              }}
              timezoneValue={timezone}
              railsTimezones={railsTimezoneData}
              onCitySelect={(cityData) => {
                form.setFieldValue('city_data', cityData);

                // Store missing city information
                if (cityData) {
                  form.setFieldValue('missing_city_detected', !cityData.cityFound);
                  form.setFieldValue('missing_city_name', cityData.missingCityName);
                }

                // console.log('City data received:', cityData);
              }}
              cityValue={form.values.city_data}
              areas={areas || []}
              cities={cities || []}
            />
          )}
        </Accordion.Panel>
      </Accordion.Item>
    </Accordion>
  );
};

export default LocationInfoSection;
